import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { domain } from "../consts";
import { InvitationWizard } from "../components/wizard";

const EditInvitationPage = () => {
  const { rsvpId } = useParams();
  const [rsvpData, setRsvpData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRSVP = async () => {
      try {
        const rsvpResponse = await fetch(`${domain}/rsvp/${rsvpId}`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!rsvpResponse.ok) {
          throw new Error(`HTTP error! Status: ${rsvpResponse.status}`);
        }

        const data = await rsvpResponse.json();
        setRsvpData(data);
      } catch (error) {
        console.error("Error fetching RSVP:", error);
        setError("Greška pri učitavanju pozivnice");
      } finally {
        setLoading(false);
      }
    };

    fetchRSVP();
  }, [rsvpId]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <svg className="animate-spin h-10 w-10 text-teal-600 mx-auto mb-4" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
          <p className="text-gray-600">Učitavanje pozivnice...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <svg className="w-16 h-16 text-red-400 mx-auto mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <p className="text-gray-600">{error}</p>
        </div>
      </div>
    );
  }

  return <InvitationWizard initialData={rsvpData} />;
};

export default EditInvitationPage;
